import RoutesConfig from './routes/Route';

function App() {
  return <RoutesConfig />;
}

export default App;
